export const DashedLine = ({ isSidebar = false }: { isSidebar?: boolean }) => {
    return (
        <div className="w-full">
            <svg viewBox="0 0 100 1" preserveAspectRatio="none" className="w-full h-[1px]">
                <line
                    x1="0"
                    y1="0.5"
                    x2="100"
                    y2="0.5"
                    stroke="#7CC58F"
                    strokeWidth="1"
                    strokeDasharray="1.3 1"
                    className={isSidebar ? undefined : "[stroke-dasharray:1.3_1] md:[stroke-dasharray:0.5_0.4]"}
                />
            </svg>
        </div>
    )
}